import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";

import LoadingOverlay from "./LoadingOverlay";
export default class Bulkquotesummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.bulkquotesummary_Id,
          sortable: true,
          cell: (row) => <span>{row.bulkquotesummary_Id}</span>,
        },
        {
          name: "Bulkquote Request Id",
          selector: (row, i) => row.bulkquoteRequestId,
          sortable: true,
          cell: (row) => <span>{row.bulkquoteRequestId}</span>,
        },
        {
          name: "Total Base Premium",
          selector: (row, i) => row.totalBasePremium,
          sortable: true,
          cell: (row) => <span>{row.totalBasePremium}</span>,
        },
        {
          name: "Maternity Addon Total",
          selector: (row, i) => row.maternityAddonTotal,
          sortable: true,
          cell: (row) => <span>{row.maternityAddonTotal}</span>,
        },
        {
          name: "Diabetis One",
          selector: (row, i) => row.diabetisOne,
          sortable: true,
          cell: (row) => <span>{row.diabetisOne}</span>,
        },
        {
          name: "Total",
          selector: (row, i) => row.total,
          sortable: true,
          cell: (row) => <span>{row.total}</span>,
        },
        {
          name: "Gst",
          selector: (row, i) => row.gst,
          sortable: true,
          cell: (row) => <span>{row.gst}</span>,
        },
        {
          name: "Buffer",
          selector: (row, i) => row.buffer,
          sortable: true,
          cell: (row) => <span>{row.buffer}</span>,
        },
        {
          name: "Grand Total",
          selector: (row, i) => row.grandTotal,
          sortable: true,
          cell: (row) => <span>{row.grandTotal}</span>,
        },
        {
          name: "Total Members",
          selector: (row, i) => row.totalMembers,
          sortable: true,
          cell: (row) => <span>{row.totalMembers}</span>,
        },
        {
          name: "Total Adults",
          selector: (row, i) => row.totalAdults,
          sortable: true,
          cell: (row) => <span>{row.totalAdults}</span>,
        },
        {
          name: "Total Children",
          selector: (row, i) => row.totalChildren,
          sortable: true,
          cell: (row) => <span>{row.totalChildren}</span>,
        },
        {
          name: "Total Parents",
          selector: (row, i) => row.totalParents,
          sortable: true,
          cell: (row) => <span>{row.totalParents}</span>,
        },
        {
          name: "Company Id",
          selector: (row, i) => row.companyId,
          sortable: true,
          cell: (row) => <span>{row.companyId}</span>,
        },
        {
          name: "Quote Generation Date",
          selector: (row, i) => row.quoteGenerationDate,
          sortable: true,
          cell: (row) => <span>{row.quoteGenerationDate}</span>,
        },
        {
          name: "Quote Requested By",
          selector: (row, i) => row.quoteRequestedBy,
          sortable: true,
          cell: (row) => <span>{row.quoteRequestedBy}</span>,
        },
        {
          name: "Buffer Amount",
          selector: (row, i) => row.bufferAmount,
          sortable: true,
          cell: (row) => <span>{row.bufferAmount}</span>,
        },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.BulkquotesummaryeditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      bulkquotesummary_Id: "",
      bulkquoteRequestId: "",
      totalBasePremium: "",
      maternityAddonTotal: "",
      diabetisOne: "",
      total: "",
      gst: "",
      buffer: "",
      grandTotal: "",
      totalMembers: "",
      totalAdults: "",
      totalChildren: "",
      totalParents: "",
      companyId: "",
      quoteGenerationDate: "",
      quoteRequestedBy: "",
      bufferAmount: "",
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName
        );
        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName
      );
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "bulkquoteRequestId",
        inputType: "Text",
        displayName: "Bulkquote Request Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "totalBasePremium",
        inputType: "Text",
        displayName: "Total Base Premium",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "maternityAddonTotal",
        inputType: "Text",
        displayName: "Maternity Addon Total",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "diabetisOne",
        inputType: "Text",
        displayName: "Diabetis One",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "total",
        inputType: "Number",
        displayName: "Total",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "gst",
        inputType: "Text",
        displayName: "Gst",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "buffer",
        inputType: "Text",
        displayName: "Buffer",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "grandTotal",
        inputType: "Number",
        displayName: "Grand Total",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "totalMembers",
        inputType: "Number",
        displayName: "Total Members",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "totalAdults",
        inputType: "Number",
        displayName: "Total Adults",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "totalChildren",
        inputType: "Number",
        displayName: "Total Children",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "totalParents",
        inputType: "Number",
        displayName: "Total Parents",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "companyId",
        inputType: "Text",
        displayName: "Company Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "quoteGenerationDate",
        inputType: "Date",
        displayName: "Quote Generation Date",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "quoteRequestedBy",
        inputType: "Text",
        displayName: "Quote Requested By",
        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      bulkquoteRequestId: "",
      totalBasePremium: "",
      maternityAddonTotal: "",
      diabetisOne: "",
      total: "",
      gst: "",
      buffer: "",
      grandTotal: "",
      totalMembers: "",
      totalAdults: "",
      totalChildren: "",
      totalParents: "",
      companyId: "",
      quoteGenerationDate: "",
      quoteRequestedBy: "",
      bufferAmount: "",
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      bulkquoteRequestId: "",
      totalBasePremium: "",
      maternityAddonTotal: "",
      diabetisOne: "",
      total: "",
      gst: "",
      buffer: "",
      grandTotal: "",
      totalMembers: "",
      totalAdults: "",
      totalChildren: "",
      totalParents: "",
      companyId: "",
      quoteGenerationDate: "",
      quoteRequestedBy: "",
      bufferAmount: "",
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  BulkquotesummaryeditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      bulkquotesummary_Id: row.bulkquotesummary_Id,
      bulkquoteRequestId: row.bulkquoteRequestId,
      totalBasePremium: row.totalBasePremium,
      maternityAddonTotal: row.maternityAddonTotal,
      diabetisOne: row.diabetisOne,
      total: row.total,
      gst: row.gst,
      buffer: row.buffer,
      grandTotal: row.grandTotal,
      totalMembers: row.totalMembers,
      totalAdults: row.totalAdults,
      totalChildren: row.totalChildren,
      totalParents: row.totalParents,
      companyId: row.companyId,
      quoteGenerationDate: row.quoteGenerationDate,
      quoteRequestedBy: row.quoteRequestedBy,
      bufferAmount: row.bufferAmount,
      //***editstate
      errors: {},
      touched: {},
    });
  };

  BulkquotesummaryfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Bulkquotesummary/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };

  BulkquotesummarysubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);
    formData.append("totalBasePremium", this.state.totalBasePremium);
    formData.append("maternityAddonTotal", this.state.maternityAddonTotal);
    formData.append("diabetisOne", this.state.diabetisOne);
    formData.append("total", this.state.total);
    formData.append("gst", this.state.gst);
    formData.append("buffer", this.state.buffer);
    formData.append("grandTotal", this.state.grandTotal);
    formData.append("totalMembers", this.state.totalMembers);
    formData.append("totalAdults", this.state.totalAdults);
    formData.append("totalChildren", this.state.totalChildren);
    formData.append("totalParents", this.state.totalParents);
    formData.append("companyId", this.state.companyId);
    formData.append("quoteGenerationDate", this.state.quoteGenerationDate);
    formData.append("quoteRequestedBy", this.state.quoteRequestedBy);
    formData.append("bufferAmount", this.state.bufferAmount);
    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Bulkquotesummary/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.BulkquotesummaryfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            bulkquoteRequestId: "",
            totalBasePremium: "",
            maternityAddonTotal: "",
            diabetisOne: "",
            total: "",
            gst: "",
            buffer: "",
            grandTotal: "",
            totalMembers: "",
            totalAdults: "",
            totalChildren: "",
            totalParents: "",
            companyId: "",
            quoteGenerationDate: "",
            quoteRequestedBy: "",
            bufferAmount: "",
          });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  };

  BulkquotesummaryupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("bulkquotesummary_Id", this.state.bulkquotesummary_Id);
    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);
    formData.append("totalBasePremium", this.state.totalBasePremium);
    formData.append("maternityAddonTotal", this.state.maternityAddonTotal);
    formData.append("diabetisOne", this.state.diabetisOne);
    formData.append("total", this.state.total);
    formData.append("gst", this.state.gst);
    formData.append("buffer", this.state.buffer);
    formData.append("grandTotal", this.state.grandTotal);
    formData.append("totalMembers", this.state.totalMembers);
    formData.append("totalAdults", this.state.totalAdults);
    formData.append("totalChildren", this.state.totalChildren);
    formData.append("totalParents", this.state.totalParents);
    formData.append("companyId", this.state.companyId);
    formData.append("quoteGenerationDate", this.state.quoteGenerationDate);
    formData.append("quoteRequestedBy", this.state.quoteRequestedBy);
    formData.append("bufferAmount", this.state.bufferAmount);
    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Bulkquotesummary/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.BulkquotesummaryfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  };

  componentDidMount() {
    this.BulkquotesummaryfetchHandler();

    //***componentDidMount
  }

  handlebulkquoteRequestIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ bulkquoteRequestId: fieldValue });
  };
  handlebufferAmountChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ bufferAmount: fieldValue });
  };
  handletotalBasePremiumChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ totalBasePremium: fieldValue });
  };
  handlematernityAddonTotalChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maternityAddonTotal: fieldValue });
  };
  handlediabetisOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ diabetisOne: fieldValue });
  };
  handletotalChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ total: fieldValue });
  };
  handlegstChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ gst: fieldValue });
  };
  handlebufferChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ buffer: fieldValue });
  };
  handlegrandTotalChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ grandTotal: fieldValue });
  };
  handletotalMembersChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ totalMembers: fieldValue });
  };
  handletotalAdultsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ totalAdults: fieldValue });
  };
  handletotalChildrenChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ totalChildren: fieldValue });
  };
  handletotalParentsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ totalParents: fieldValue });
  };
  handlecompanyIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ companyId: fieldValue });
  };
  handlequoteGenerationDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ quoteGenerationDate: fieldValue });
  };
  handlequoteRequestedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ quoteRequestedBy: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(`Are you sure you want to delete this bulkquotesummary?`)
    ) {
      return;
    }

    var formData = new FormData();
    formData.append("bulkquotesummary_Id", row.bulkquotesummary_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Bulkquotesummary/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.BulkquotesummaryfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":
      case "dob_adult":
      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case "telephone":
      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case "mail":
      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Bulkquote Summary
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Bulkquotesummary
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Bulkquote Request Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlebulkquoteRequestIdChange
                                        }
                                        className="form-control"
                                        name="bulkquoteRequestId"
                                        value={this.state.bulkquoteRequestId}
                                        required="required"
                                        placeholder="Enter Bulkquote Request Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.bulkquoteRequestId
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Total Base Premium
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handletotalBasePremiumChange
                                        }
                                        className="form-control"
                                        name="totalBasePremium"
                                        value={this.state.totalBasePremium}
                                        required="required"
                                        placeholder="Enter Total Base Premium"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.totalBasePremium}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Maternity Addon Total
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlematernityAddonTotalChange
                                        }
                                        className="form-control"
                                        name="maternityAddonTotal"
                                        value={this.state.maternityAddonTotal}
                                        required="required"
                                        placeholder="Enter Maternity Addon Total"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.maternityAddonTotal
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Diabetis One
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlediabetisOneChange}
                                        className="form-control"
                                        name="diabetisOne"
                                        value={this.state.diabetisOne}
                                        required="required"
                                        placeholder="Enter Diabetis One"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.diabetisOne}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Total
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handletotalChange}
                                        className="form-control"
                                        name="total"
                                        value={this.state.total}
                                        required="required"
                                        placeholder="Enter Total"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.total}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Gst
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlegstChange}
                                        className="form-control"
                                        name="gst"
                                        value={this.state.gst}
                                        required="required"
                                        placeholder="Enter Gst"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.gst}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Buffer
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlebufferChange}
                                        className="form-control"
                                        name="buffer"
                                        value={this.state.buffer}
                                        required="required"
                                        placeholder="Enter Buffer"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.buffer}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Grand Total
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlegrandTotalChange}
                                        className="form-control"
                                        name="grandTotal"
                                        value={this.state.grandTotal}
                                        required="required"
                                        placeholder="Enter Grand Total"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.grandTotal}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Total Members
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handletotalMembersChange}
                                        className="form-control"
                                        name="totalMembers"
                                        value={this.state.totalMembers}
                                        required="required"
                                        placeholder="Enter Total Members"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.totalMembers}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Total Adults
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handletotalAdultsChange}
                                        className="form-control"
                                        name="totalAdults"
                                        value={this.state.totalAdults}
                                        required="required"
                                        placeholder="Enter Total Adults"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.totalAdults}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Total Children
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handletotalChildrenChange
                                        }
                                        className="form-control"
                                        name="totalChildren"
                                        value={this.state.totalChildren}
                                        required="required"
                                        placeholder="Enter Total Children"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.totalChildren}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Total Parents
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handletotalParentsChange}
                                        className="form-control"
                                        name="totalParents"
                                        value={this.state.totalParents}
                                        required="required"
                                        placeholder="Enter Total Parents"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.totalParents}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlecompanyIdChange}
                                        className="form-control"
                                        name="companyId"
                                        value={this.state.companyId}
                                        required="required"
                                        placeholder="Enter Company Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Quote Generation Date
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handlequoteGenerationDateChange
                                        }
                                        className="form-control"
                                        name="quoteGenerationDate"
                                        value={this.state.quoteGenerationDate}
                                        required="required"
                                        placeholder="Enter Quote Generation Date"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.quoteGenerationDate
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Quote Requested By
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlequoteRequestedByChange
                                        }
                                        className="form-control"
                                        name="quoteRequestedBy"
                                        value={this.state.quoteRequestedBy}
                                        required="required"
                                        placeholder="Enter Quote Requested By"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.quoteRequestedBy}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Buffer Amount
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlebufferAmountChange}
                                        className="form-control"
                                        name="bufferAmount"
                                        value={this.state.bufferAmount}
                                        required="required"
                                        placeholder="Enter Buffer Amount"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.bufferAmount}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.BulkquotesummarysubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Bulkquotesummary
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Bulkquote Request Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlebulkquoteRequestIdChange
                                          }
                                          className="form-control"
                                          name="bulkquoteRequestId"
                                          value={this.state.bulkquoteRequestId}
                                          required="required"
                                          placeholder="Enter Bulkquote Request Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.bulkquoteRequestId
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Total Base Premium
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handletotalBasePremiumChange
                                          }
                                          className="form-control"
                                          name="totalBasePremium"
                                          value={this.state.totalBasePremium}
                                          required="required"
                                          placeholder="Enter Total Base Premium"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.totalBasePremium
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Maternity Addon Total
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlematernityAddonTotalChange
                                          }
                                          className="form-control"
                                          name="maternityAddonTotal"
                                          value={this.state.maternityAddonTotal}
                                          required="required"
                                          placeholder="Enter Maternity Addon Total"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.maternityAddonTotal
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Diabetis One
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlediabetisOneChange
                                          }
                                          className="form-control"
                                          name="diabetisOne"
                                          value={this.state.diabetisOne}
                                          required="required"
                                          placeholder="Enter Diabetis One"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.diabetisOne}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Total
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handletotalChange}
                                          className="form-control"
                                          name="total"
                                          value={this.state.total}
                                          required="required"
                                          placeholder="Enter Total"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.total}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Gst
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlegstChange}
                                          className="form-control"
                                          name="gst"
                                          value={this.state.gst}
                                          required="required"
                                          placeholder="Enter Gst"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.gst}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Buffer
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlebufferChange}
                                          className="form-control"
                                          name="buffer"
                                          value={this.state.buffer}
                                          required="required"
                                          placeholder="Enter Buffer"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.buffer}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Grand Total
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlegrandTotalChange}
                                          className="form-control"
                                          name="grandTotal"
                                          value={this.state.grandTotal}
                                          required="required"
                                          placeholder="Enter Grand Total"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.grandTotal}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Total Members
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handletotalMembersChange
                                          }
                                          className="form-control"
                                          name="totalMembers"
                                          value={this.state.totalMembers}
                                          required="required"
                                          placeholder="Enter Total Members"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.totalMembers}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Total Adults
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handletotalAdultsChange
                                          }
                                          className="form-control"
                                          name="totalAdults"
                                          value={this.state.totalAdults}
                                          required="required"
                                          placeholder="Enter Total Adults"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.totalAdults}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Total Children
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handletotalChildrenChange
                                          }
                                          className="form-control"
                                          name="totalChildren"
                                          value={this.state.totalChildren}
                                          required="required"
                                          placeholder="Enter Total Children"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.totalChildren}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Total Parents
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handletotalParentsChange
                                          }
                                          className="form-control"
                                          name="totalParents"
                                          value={this.state.totalParents}
                                          required="required"
                                          placeholder="Enter Total Parents"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.totalParents}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Company Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlecompanyIdChange}
                                          className="form-control"
                                          name="companyId"
                                          value={this.state.companyId}
                                          required="required"
                                          placeholder="Enter Company Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.companyId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Quote Generation Date
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handlequoteGenerationDateChange
                                          }
                                          className="form-control"
                                          name="quoteGenerationDate"
                                          value={this.state.quoteGenerationDate}
                                          required="required"
                                          placeholder="Enter Quote Generation Date"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.quoteGenerationDate
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Quote Requested By
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlequoteRequestedByChange
                                          }
                                          className="form-control"
                                          name="quoteRequestedBy"
                                          value={this.state.quoteRequestedBy}
                                          required="required"
                                          placeholder="Enter Quote Requested By"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.quoteRequestedBy
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Buffer Amount
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlebufferAmountChange
                                          }
                                          className="form-control"
                                          name="bufferAmount"
                                          value={this.state.bufferAmount}
                                          required="required"
                                          placeholder="Enter Buffer Amount"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.bufferAmount}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.BulkquotesummaryupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
